module.exports = __webpack_public_path__ + "0fc3422edc3a82b1f5bb715c1e02be96.pdf";